import axios from "axios";

export default async function newTemplate(projectName, formName, {...data}){

    await axios.patch(`/project/${projectName}/${formName}/template`, {...data})
}